
import { defineComponent } from 'vue';
import { Field, FieldBig } from './charts';
import Trend from './trend/index.vue';
import numeral from 'numeral';

export default defineComponent({
  name: 'ShopDeskTop',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup() {
    return {
      numeral,
    };
  },
  components: {
    Field,
    Trend,
    FieldBig,
  },
});
